/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.19.0
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { OPEN_LABEL_EDITOR } from '../../../constants/actionConstants';
import { LabelEditorActionsType } from './labelEditorActions';
import {
    LABEL_EDITOR_CREATE,
    LABEL_EDITOR_CREATE_FAILED,
    LABEL_EDITOR_CREATE_SUCCESSFUL,
    LABEL_EDITOR_LOAD_LIST,
    LABEL_EDITOR_LOAD_LIST_FAILED,
    LABEL_EDITOR_LOAD_LIST_SUCCESSFUL,
    LABEL_EDITOR_SEARCH,
    LABEL_EDITOR_SWITCH,
    LABEL_EDITOR_UPDATE,
    LABEL_EDITOR_UPDATE_FAILED,
    LABEL_EDITOR_UPDATE_SUCCESSFUL,
} from './labelEditorConstants';
import { EEditableLabel, IEditableLabel } from './labelEditorTypes';

export interface ILabelEditorReducerState {
    isLoading: boolean;
    labels: IEditableLabel[];
    message: string;
    searchValue: string;
    type: EEditableLabel;
}

export const initialLabelEditorState: ILabelEditorReducerState = {
    labels: [],
    isLoading: false,
    message: '',
    searchValue: '',
    type: EEditableLabel.mobile,
};

const labelEditorReducer: Reducer<ILabelEditorReducerState, LabelEditorActionsType> =
    (state = initialLabelEditorState, action: LabelEditorActionsType) =>
        produce(state, draft => {
            switch (action.type) {
                case OPEN_LABEL_EDITOR:
                    draft.type = action.payload;
                    break;

                // LOAD LABEL LIST
                case LABEL_EDITOR_LOAD_LIST:
                    draft.isLoading = true;
                    if (action.payload.clearList) {
                        draft.labels = [];
                    }
                    break;
                case LABEL_EDITOR_LOAD_LIST_SUCCESSFUL:
                    draft.isLoading = false;
                    // Remember checked labels
                    const checkedLabels = draft.labels.filter(item => item.checked).map(item => item.id);
                    // Restore checked labels
                    draft.labels = action.payload.map(item => ({
                        ...item,
                        checked: item.checked || checkedLabels.indexOf(item.id) >= 0,
                    }));
                    break;
                case LABEL_EDITOR_LOAD_LIST_FAILED:
                    draft.isLoading = false;
                    draft.message = action.payload;
                    break;

                // CREATE LABEL
                case LABEL_EDITOR_CREATE:
                    break;
                case LABEL_EDITOR_CREATE_SUCCESSFUL:
                    draft.labels = [...draft.labels, action.payload];
                    break;
                case LABEL_EDITOR_CREATE_FAILED:
                    draft.message = action.payload;
                    break;

                //  UPDATE LABEL LIST
                case LABEL_EDITOR_UPDATE:
                    break;
                case LABEL_EDITOR_UPDATE_SUCCESSFUL:
                    draft.labels = [];
                    draft.message = '';
                    draft.searchValue = '';
                    break;
                case LABEL_EDITOR_UPDATE_FAILED:
                    draft.message = action.payload;
                    break;

                // SEARCH LABELS
                case LABEL_EDITOR_SEARCH:
                    draft.searchValue = action.payload;
                    break;

                // SWITCH LABELS
                case LABEL_EDITOR_SWITCH:
                    draft.labels = action.payload;
                    break;
                default:
                    break;
            }
        });

export default labelEditorReducer;
